import { render, staticRenderFns } from "./CuentaAliadaListView.vue?vue&type=template&id=65178248"
import script from "./CuentaAliadaListView.vue?vue&type=script&lang=js"
export * from "./CuentaAliadaListView.vue?vue&type=script&lang=js"
import style0 from "./CuentaAliadaListView.vue?vue&type=style&index=0&id=65178248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports